import React from "react";
import DatePicker from 'react-datepicker';
import DateHelper from '../DateHelper/DateHelper'
import 'date-fns'

export default class DashboardDatePicker extends React.Component{
  constructor(props){
    super(props);
  };

  render() {
    return(
      <div className='DashboardDatePicker'>
        <DatePicker
          className={this.props.classNames ? this.props.classNames + ' dashboard-picker-input' : 'dashboard-picker-input'}
          dateFormat={DateHelper.rubyToDateFNS(this.props.dateFormat)}
          dayClassName={date => 'DatePickerInput-calendar-days'}
          selected={this.props.selectedDate}
          showPopperArrow={false}
          todayButton={I18n.t('today')}
          showMonthDropdown
          showYearDropdown
          onChange={this.props.onChange}
        />
      </div>
    );
  };
};
